import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../api/api";
 
import InputField from "../../../../components/InputField";
import BackButton from "../../../../components/BackButton";
 
import PersonIcon from "@mui/icons-material/Person";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import ContactMailIcon from "@mui/icons-material/ContactMail";
 
import "../../Common/form.css";
import "../../Admin/MasterData/vendorform.css";
 
const ViewVendorOnboarding = () => {
  const { id } = useParams();
 
  const [loading, setLoading] = useState(true);
 
  const [vendor, setVendor] = useState({});
  const [pocs, setPocs] = useState([]);
  const [documents, setDocuments] = useState([]);
 
  const getPocField = (pocType, fieldName) => {
    const poc = pocs.find((p) => p.poc_type === pocType);
    return poc ? poc[fieldName] || "" : "";
  };
 
  const getDocumentUrl = (docType) => {
    const doc = documents.find((d) => d.document_type === docType);
    return doc ? doc.document_url : null;
  };
 
  const documentList = [
    {
      name: "cin_certificate",
      label: "CIN Certificate",
      description: "Company incorporation certificate",
    },
    {
      name: "gstn",
      label: "GSTN",
      description: "GST registration certificate",
    },
    {
      name: "pan",
      label: "PAN",
      description: "Company PAN document",
    },
    {
      name: "cancelled_cheque",
      label: "Cancelled Cheque",
      description: "Company bank account cheque",
    },
    {
      name: "company_identification_certificate",
      label: "Company Identification Certificate",
      description: "Company identification document",
    },
  ];
 
  const vendorTypeOptions = [
    {
      value: "Vendor",
      label: "Vendor",
    },
    {
      value: "Service Provider",
      label: "Service Provider",
    },
    {
      value: "Vendor & Service Provider",
      label: "Vendor & Service Provider",
    },
  ];
 
  const segmentOptions = [
{
    value: "FE",
    label: "FE",
  },
  {
    value: "LE",
    label: "LE",
  },
  {
    value: "LI",
    label: "LI",
  },
  {
    value: "FI",
    label: "FI",
  },
  ];
 
  // =================================================
  // GET VENDOR DETAILS
  // =================================================
 
  useEffect(() => {
    const fetchVendor = async () => {
      try {
        setLoading(true);
 
        console.log("Fetching vendor:", id);
 
        const response = await api.get(`/master-data/vendor-master/${id}`);
        setVendor(response.data.vendor || {});
        setPocs(response.data.pocs || []);
        setDocuments(response.data.documents || []);
      } catch (error) {
        console.error("Error fetching vendor:", error);
      } finally {
        setLoading(false);
      }
    };
 
    if (id) {
      fetchVendor();
    }
  }, [id]);
 
  // =================================================
  // VIEW DOCUMENT
  // =================================================
 
  const handleViewDocument = (document) => {
    if (!document) return;
 
    // Agar API se URL aa raha hai
    if (typeof document === "string") {
      window.open(document, "_blank", "noopener,noreferrer");
      return;
    }
 
    // Agar File object hai
    if (document instanceof File) {
      const fileUrl = URL.createObjectURL(document);
 
      window.open(fileUrl, "_blank", "noopener,noreferrer");
 
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 60000);
    }
  };
 
  if (loading) {
    return (
      <>
        <BackButton />
 
        <div className="vendor-master-page">
          <div className="text-center py-5">
            Loading vendor details...
          </div>
        </div>
      </>
    );
  }
 
  return (
    <>
      <BackButton/>
 
      <div className="vendor-master-page">
        {/* =================================================
            01 COMPANY DETAILS
        ================================================== */}
 
        <fieldset className="vendor-section mt-4">
          <legend className="vendor-section-legend">
            <span className="vendor-section-icon">
              <PersonIcon fontSize="small" />
            </span>
 
            <span className="vendor-section-title">
              Company Details
            </span>
          </legend>
 
          <p className="vendor-section-description">
            Company registration and address information.
          </p>
 
          <div className="vendor-section-body">
            <div className="row g-3 mb-3">
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Company Name"
                  name="company_name"
                  value={vendor.name || ""}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="GST/TAN No."
                  name="gst_tan_no"
                  value={vendor.gst_number || ""}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="PAN No."
                  name="pan_no"
                  value={vendor.pan_number || ""}
                  readOnly
                />
              </div>
 
              {/* <div className="col-12 col-md-6 col-lg-4">
                <SelectField
                  label="Vendor/Service Type"
                  name="vendor_service_type"
                  value={vendor.vendor_service_type}
                  options={vendorTypeOptions}
                  disabled
                />
              </div> */}
              <div className="col-12 col-md-6 col-lg-4">
  <InputField
    label="Vendor/Service Type"
    name="vendor_service_type"
    value={vendor.vendor_kind || ""}
    readOnly
  />
</div>
 
           
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Company CIN No."
                  name="company_cin_no"
                  value={vendor.company_cin_no || ""}
                  readOnly
                />
              </div>
               {/* <div className="col-12 col-md-6 col-lg-4">
                <SelectField
                  label="Segment"
                  name="segment"
                  value={vendor.segment}
                  options={segmentOptions}
                  disabled
                />
              </div> */}
              <div className="col-12 col-md-6 col-lg-4">
  <InputField
    label="Segment"
    name="segment"
    value={vendor.segment_type || ""}
    readOnly
  />
</div>
 
            </div>
 
            {/* REGISTERED ADDRESS */}
 
            <div className="vendor-subsection">
              <div className="vendor-subsection-title">
                Registered Address
              </div>
 
              <div className="row g-3">
 
                 <div className="col-12 col-lg-6">
                   <InputField
                     label="Flat/House No./Building/Company/Apartment"
                     name="flat_house_building"
                     value={vendor.address_flat || ""}
                     readOnly
                   />
                 </div>
 
                 <div className="col-12 col-lg-6">
                   <InputField
                     label="Area/Street/Sector/Town/Village"
                     name="area_street_sector"
                     value={vendor.address_area || ""}
                     readOnly
                   />
                 </div>
 
                 <div className="col-12 col-md-4">
                   <InputField
                     label="Country"
                     name="country"
                     value={vendor.address_country || ""}
                     readOnly
                   />
                 </div>
 
                 <div className="col-12 col-md-4">
                   <InputField
                     label="State"
                     name="state"
                     value={vendor.address_state || ""}
                     readOnly
                   />
                 </div>
 
                 <div className="col-12 col-md-4">
                   <InputField
                     label="Pincode"
                     name="pincode"
                     value={vendor.address_pincode || ""}
                     readOnly
                   />
                 </div>
 
              </div>
            </div>
          </div>
        </fieldset>
 
        {/* =================================================
            02 CONTACT DETAILS
        ================================================== */}
 
        <fieldset className="vendor-section mt-4">
          <legend className="vendor-section-legend">
            <span className="vendor-section-icon">
              <ContactMailIcon fontSize="small" />
            </span>
 
            <span className="vendor-section-title">
              Contact Details
            </span>
          </legend>
 
          <p className="vendor-section-description">
            Authorised and assigned points of contact.
          </p>
 
          <div className="vendor-section-body">
 
            {/* POC 1 */}
 
            <div className="vendor-poc-header">
              <div className="vendor-poc-heading">
                <span className="vendor-poc-label">
                  POC - 1
                </span>
 
                <span className="vendor-poc-badge authorised">
                  Authorised
                </span>
              </div>
            </div>
 
            <div className="row g-3">
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Full Name"
                  name="poc1_full_name"
                  value={getPocField("AUTHORISED", "full_name")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Designation"
                  name="poc1_designation"
                  value={getPocField("AUTHORISED", "designation")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mail ID"
                  name="poc1_email"
                  value={getPocField("AUTHORISED", "email")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mobile No."
                  name="poc1_mobile"
                  value={getPocField("AUTHORISED", "mobile")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Telephone No."
                  name="poc1_telephone"
                  value={getPocField("AUTHORISED", "telephone")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Extension No."
                  name="poc1_extension"
                  value={getPocField("AUTHORISED", "extension")}
                  readOnly
                />
              </div>
 
            </div>
 
            {/* POC 2 */}
 
            <div className="vendor-poc-header">
              <div className="vendor-poc-heading">
                <span className="vendor-poc-label">
                  POC - 2
                </span>
 
                <span className="vendor-poc-badge assigned">
                  Assigned
                </span>
              </div>
            </div>
 
            <div className="row g-3">
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Full Name"
                  name="poc2_full_name"
                  value={getPocField("ASSIGNED", "full_name")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Designation"
                  name="poc2_designation"
                  value={getPocField("ASSIGNED", "designation")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mail ID"
                  name="poc2_email"
                  value={getPocField("ASSIGNED", "email")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Mobile No."
                  name="poc2_mobile"
                  value={getPocField("ASSIGNED", "mobile")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Telephone No."
                  name="poc2_telephone"
                  value={getPocField("ASSIGNED", "telephone")}
                  readOnly
                />
              </div>
 
              <div className="col-12 col-md-6 col-lg-4">
                <InputField
                  label="Extension No."
                  name="poc2_extension"
                  value={getPocField("ASSIGNED", "extension")}
                  readOnly
                />
              </div>
 
            </div>
          </div>
        </fieldset>
 
        {/* =================================================
            03 SUPPORTING DOCUMENTS
        ================================================== */}
 
        <fieldset className="vendor-section mt-4">
          <legend className="vendor-section-legend">
            <span className="vendor-section-icon">
              <ContactSupportIcon fontSize="small" />
            </span>
 
            <span className="vendor-section-title">
              Supporting Docs Checklist
            </span>
          </legend>
 
          <p className="vendor-section-description">
            Uploaded vendor documents.
          </p>
 
          <div className="vendor-section-body">
            <div className="row g-3 mb-3">
 
              {documentList.map((doc) => {
                const uploadedFile = getDocumentUrl(doc.name);
 
                return (
                  <div
                    className="col-12 col-md-6 col-lg-4"
                    key={doc.name}
                  >
                    <div
                      className={`vendor-document-upload-card ${
                        uploadedFile ? "uploaded" : ""
                      }`}
                    >
 
                      <div className="vendor-document-info">
                        <div
                          className={`vendor-document-icon ${
                            uploadedFile ? "success" : ""
                          }`}
                        >
                          {uploadedFile ? "✓" : "PDF"}
                        </div>
 
                        <div className="vendor-document-title">
                          <span>{doc.label}</span>
 
                          <small>
                            {doc.description}
                          </small>
                        </div>
                      </div>
 
                      {uploadedFile ? (
                        <>
                          <div className="vendor-document-actions">
                            <button
                              type="button"
                              className="vendor-view-btn"
                              onClick={() =>
                                handleViewDocument(uploadedFile)
                              }
                            >
                              View PDF
                            </button>
                          </div>
 
                          <div
                            className="vendor-file-name"
                            title={
                              typeof uploadedFile === "string"
                                ? uploadedFile
                                : uploadedFile.name
                            }
                          >
                            📄{" "}
                            {typeof uploadedFile === "string"
                              ? "Uploaded Document"
                              : uploadedFile.name}
                          </div>
                        </>
                      ) : (
                        <div className="text-muted small mt-2">
                          Document not uploaded
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
 
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};
 
export default ViewVendorOnboarding;